
import React, { useState } from "react";
import IndependentResearcherFeed from "./IndependentResearcherFeed";
import IndependentResearcherRealWorldProblems from "./IndependentResearcherRealWorldProblems";
import { IndependentResearherProfile } from "./IndependentResearherProfile"
import IndustryProfiles from "./IndustryProfiles";
const IndependentResearcherHome = ({searchTerm,searchParams,setSearchResults}) => {
   const [activeTab,setActiveTab] = useState("feed")
  return (
    <div className="container mx-auto md:px-4 mt-6 mb-4">

      <div className="flex relative">
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndependentResearherProfile />
          </div>
        </div>
        {/* Center Section */}
        <div className="w-full md:w-2/4 md:px-2">
         <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
          <div className="flex gap-4 w-full pb-4">
  <button onClick={()=>setActiveTab('feed')} className={`w-1/2 py-2 text-center ${activeTab === 'feed' ? 'bg-blue-500' :'bg-gray-200'} text-white rounded-[10px]`}>
    Feed
  </button>
  <button onClick={()=>setActiveTab('opportunity')} className={`w-1/2 py-2 text-center ${activeTab === 'opportunity' ? 'bg-blue-500' :'bg-gray-200'} text-white rounded-[10px]`}>
    Opportunity
  </button>
</div>
           {
            activeTab === 'feed' ?  <IndependentResearcherFeed searchTerm={searchTerm} searchParams={searchParams} setSearchResults={setSearchResults}/> : <IndependentResearcherRealWorldProblems/>
           }
          </div>
        </div>
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px]  max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndustryProfiles/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(IndependentResearcherHome)